import classNames from "classnames";
import React from "react";
import styles from "../../styles/Form.module.css";
import PulseLoader from "../Loader/PulseLoader";

interface ButtonProps {
  children?: JSX.Element | string;
  className?: string;
  color?: string;
  disabled?: boolean;
  icon?: JSX.Element;
  iconOnRight?: boolean;
  loading?: boolean;
  onClick?: () => void;
  noBorder?: boolean;
  padding?: string;
  rounded?: "left" | "right" | "both";
  type?: "submit" | "button" | "reset" | undefined;
}

function MinorButton({
  children,
  color = "white",
  className,
  disabled = false,
  icon,
  iconOnRight,
  loading = false,
  noBorder,
  onClick,
  padding = "px-3 py-2",
  rounded = "both",
  type = "button",
}: ButtonProps): JSX.Element {
  const content = loading ? (
    <PulseLoader colorVar="primary-text" size={1.5} />
  ) : (
    children
  );

  const roundClass =
    rounded === "both"
      ? "rounded-md"
      : rounded === "left"
        ? "rounded-l-md"
        : "rounded-r-md";

  let borderClass = "ring-1 ring-inset ring-[--primary-color]";
  if (color == "warning") borderClass = "ring-1 ring-inset ring-yellow-800";
  if (noBorder) borderClass = "";

  return (
    <button
      className={classNames(
        className,
        borderClass,
        roundClass,
        padding,
        styles.link,
        disabled ? "cursor-not-allowed opacity-60" : "",
        color == "white"
          ? "bg-white text-[--primary-color] hover:bg-gray-50"
          : null,
        color == "warning"
          ? "bg-yellow-50 text-yellow-900 hover:bg-yellow-300"
          : null,
        "relative inline-flex items-center text-sm font-bold  focus:z-10",
      )}
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {icon && !iconOnRight && <span className="mr-1.5">{icon}</span>}
      {content}
      {icon && iconOnRight && <span className="ml-1.5">{icon}</span>}
    </button>
  );
}

export default MinorButton;
